import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MaybeAsync } from '@datorama/akita';
import {fromPromise} from "rxjs/internal/observable/innerFrom";
import {Preferences, GetResult} from "@capacitor/preferences";
import {PersistStateStorage} from "@datorama/akita/lib/persistState";

@Injectable({ providedIn: 'root' })
export class LocalStorageService implements PersistStateStorage {
  constructor() {}

  setSavedState(state: any, localPreferencesKey: string) {
    Preferences.set({ key: localPreferencesKey, value: JSON.stringify(state) });
  }

  getSavedState(localPreferencesKey: string): Observable<any> {
    return fromPromise(Preferences.get({ key: localPreferencesKey })).pipe(
      map((value: GetResult) => JSON.parse(value.value))
    );
  }

  clear(): void {
    Preferences.clear();
  }

  getItem(key: string): MaybeAsync {
    return fromPromise(Preferences.get({ key: key })).pipe(
      map((value: GetResult) => JSON.parse(value.value))
    );
  }

  setItem(key: string, value: any): MaybeAsync {
    return fromPromise(Preferences.set({ key: key, value: JSON.stringify(value) }));
  }

  getKey(key: string): Observable<any> {
    return fromPromise(Preferences.get({ key: key })).pipe(
      map((value: GetResult) => JSON.parse(value.value))
    );
  }

  async setKey(key: string, value: any) {
    return Preferences.set({ key: key, value: JSON.stringify(value) });
  }
}
